import { gql } from '@apollo/client';

export const FEED_USER_FIELDS = gql`
  fragment FeedUserFields on User {
    id
    name
    profilePictureUrl
    profile {
      admin
    }
  }
`;

export const FEED_EVENT_ITEM = gql`
  fragment FeedEventItem on NewsFeedEventItem {
    id
    title
    description
    posterImageUrl
    startTime
    endTime
    locationName
    userRSVP
    userReminder
    cancelled
    isNew
    creationDate
    likes
    mainCategory {
      id
      name
      icon
    }
    author {
      ...FeedUserFields
    }
    comments {
      id
      body
      userName
      createdAt
      userProfileImg
    }
  }
  ${FEED_USER_FIELDS}
`;

export const FEED_NEWS_ITEM = gql`
  fragment FeedNewsItem on NewsFeedNewsItem {
    id
    title
    description
    posterImageUrl
    link
    creationDate
    isNew
    likes
    mainCategory {
      id
      name
      icon
    }
    author {
      ...FeedUserFields
    }
    comments {
      id
      body
      userName
      createdAt
      userProfileImg
    }
  }
  ${FEED_USER_FIELDS}
`;

export const FEED_POLL_ITEM = gql`
  fragment FeedPollItem on NewsFeedPollItem {
    id
    question
    possibleAnswers {
      answer
      value
    }
    userAnswered
    creationDate
    likes
    mainCategory {
      id
      name
      icon
    }
    author {
      ...FeedUserFields
    }
    comments {
      id
      body
      userName
      createdAt
      userProfileImg
    }
  }
  ${FEED_USER_FIELDS}
`;

export const FEED_SPORT_ITEM = gql`
  fragment FeedSportItem on NewsFeedSportItem {
    id
    title
    description
    posterImageUrl
    startTime
    score
    opponent
    locationName
    userRSVP
    userReminder
    cancelled
    isNew
    likes
    mainCategory {
      id
      name
      icon
    }
    author {
      ...FeedUserFields
    }
    comments {
      id
      body
      userName
      createdAt
      userProfileImg
    }
  }
  ${FEED_USER_FIELDS}
`;
